import React, { lazy } from 'react'
import {
  navigationCollectionsAccessControl,
  navigationViewAccessControl,
  pageBuilderModifyAccessControl,
  pageBuilderViewAccessControl,
  storeConfigurationDraftViewAccessControl,
  storefrontAccessControl,
} from 'domains/storefront/access-control/storefrontAccess.configuration'
import { DomainRoute } from 'domains/storefront/utils/domain/routingComponents'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import {
  autosuggestModifyAccessControl,
  autosuggestViewAccessControl,
} from 'domains/storefront/access-control/autosuggestAccess.configuration'

const StorefrontNavigationHeaderPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontNavigationHeaderPage" */
      'domains/storefront/pages/navigation/StorefrontNavigationHeaderPage'
    )
)
const StorefrontBrandSettingsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontBrandSettingsPage" */
      'domains/storefront/pages/brand-settings/StorefrontBrandSettingsPage'
    )
)
const StorefrontNavigationFooterPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontNavigationFooterPage" */
      'domains/storefront/pages/navigation/StorefrontNavigationFooterPage'
    )
)
const StorefrontContentPagesDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontContentPagesDashboardPage" */
      'domains/storefront/pages/content-pages-dashboard/StorefrontContentPagesDashboardPage'
    )
)
const StorefrontContentPagesBuilder = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontContentPagesBuilder" */
      'domains/storefront/pages/content-pages-builder/StorefrontContentPagesBuilderPage'
    )
)

const StorefrontHomepageDashboard = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontHomepageDashboardPage" */
      'domains/storefront/pages/homepage-dashboard/StorefrontHomepageDashboardPage'
    )
)

const StorefrontHomepageBuilder = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontHomepageBuilderPage" */
      'domains/storefront/pages/homepage-builder/StorefrontHomepageBuilderPage'
    )
)

const StorefrontNavigationCollectionsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontNavigationCollectionsPage" */
      'domains/storefront/pages/navigation/StorefrontNavigationCollectionsPage'
    )
)
const StorefrontAutosuggestLinksListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontAutosuggestLinksListPage" */
      'domains/storefront/pages/autosuggest-links/StorefrontAutosuggestLinksListPage'
    )
)
const StorefrontAutosuggestLinksUpsertPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontAutosuggestLinksUpsertPage" */
      'domains/storefront/pages/autosuggest-links/StorefrontAutosuggestLinksUpsertPage'
    )
)
const StorefrontAutosuggestLinksViewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontAutosuggestLinksViewPage" */
      'domains/storefront/pages/autosuggest-links/StorefrontAutosuggestLinksViewPage'
    )
)
// @hygen:inject page-import

export const storefrontRouter = (
  <DomainRoute route="storefront" accessControl={storefrontAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="storefront-brand-settings"
        component={StorefrontBrandSettingsPage}
        accessControl={storeConfigurationDraftViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-navigation-header"
        component={StorefrontNavigationHeaderPage}
        accessControl={navigationViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-navigation-footer"
        component={StorefrontNavigationFooterPage}
        accessControl={navigationViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-dashboard"
        component={StorefrontContentPagesDashboardPage}
        accessControl={pageBuilderViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-create"
        component={StorefrontContentPagesBuilder}
        accessControl={pageBuilderModifyAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-edit"
        component={StorefrontContentPagesBuilder}
        accessControl={pageBuilderViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-content-pages-edit-version"
        component={StorefrontContentPagesBuilder}
        accessControl={pageBuilderViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-navigation-collections"
        component={StorefrontNavigationCollectionsPage}
        accessControl={navigationCollectionsAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-homepage-dashboard"
        component={StorefrontHomepageDashboard}
        accessControl={pageBuilderViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-homepage-edit"
        component={StorefrontHomepageBuilder}
        accessControl={pageBuilderViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-autosuggest-links-list"
        component={StorefrontAutosuggestLinksListPage}
        accessControl={autosuggestViewAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-autosuggest-links-upsert"
        component={StorefrontAutosuggestLinksUpsertPage}
        accessControl={autosuggestModifyAccessControl}
      />
      <DomainRoute
        exact
        route="storefront-autosuggest-links-view"
        component={StorefrontAutosuggestLinksViewPage}
        accessControl={autosuggestViewAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
